import React from "react"

const UTF8_BOM = "\uFEFF"

const triggerDownload = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", `${fileName}.csv`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

const withUtf8Bom = (text) =>
  text.charCodeAt(0) === 0xfeff ? text : `${UTF8_BOM}${text}`

const DownloadCSV = (csvData, fileName) => {
  // Excel needs a UTF-8 BOM to show emojis / Arabic correctly in CSV
  if (csvData instanceof Blob) {
    csvData.text().then((text) => {
      const blob = new Blob([withUtf8Bom(text)], {
        type: "text/csv;charset=utf-8;",
      })
      triggerDownload(blob, fileName)
    })
    return
  }

  const text = String(csvData ?? "")
  const blob = new Blob([withUtf8Bom(text)], {
    type: "text/csv;charset=utf-8;",
  })
  triggerDownload(blob, fileName)
}

export default DownloadCSV
